import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { MobileAppSection } from "@/components/MobileAppSection";
import { UXSection } from "@/components/UXSection";
import { DesignSection } from "@/components/DesignSection";
import { WorkProcess } from "@/components/WorkProcess";
import { RunningPills } from "@/components/RunningPills";
import { SupabaseTest } from "@/components/SupabaseTest";
import { ImageDebug } from "@/components/ImageDebug";
import { Footer } from "@/components/Footer";

const Index = () => {
  const isDev = import.meta.env.DEV;

  return (
    <main className="min-h-screen">
      {/* {isDev && (
        <>
          <ImageDebug />
          <SupabaseTest />
        </>
      )} */}
      <Hero />
      <WorkProcess />
      <RunningPills />
      <Services />
      <MobileAppSection />
      <DesignSection />
      {/* <UXSection /> */}
      <Footer />
    </main>
  );
};

export default Index;